import React from 'react';
import { getStorage } from 'firebase/storage';
import { useFirebase } from '../services/firebase';
import { getPreviewDownloadUrl } from '../services/firebase/storage';

export default function useRemotePreviewUrl(
  filename?: string,
  userId?: string
): { url?: string; status: 'idle' | 'loading' | 'ready' | 'error' } {
  const { app } = useFirebase();
  const [state, setState] = React.useState<{
    url?: string;
    status: 'idle' | 'loading' | 'ready' | 'error';
  }>({ status: 'idle' });

  React.useEffect(() => {
    if (!filename || !userId || !app) {
      setState({ status: 'idle' });
      return;
    }

    let cancelled = false;
    setState({ status: 'loading' });

    const storage = getStorage(app);
    getPreviewDownloadUrl(storage, filename, userId)
      .then(({ url }) => {
        if (!cancelled) {
          setState({ url, status: 'ready' });
        }
      })
      .catch((error) => {
        console.warn('Failed to load thumbnail preview', error);
        if (!cancelled) {
          setState({ status: 'error' });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [filename, userId, app]);

  return state;
}
